import { ifElse, pipe, prop, tryCatch } from "ramda";
import { detect } from "detect-browser";

export const isMobile = () =>
  ["iOS", "Windows Mobile", "Android OS", "BlackBerry OS"].includes(
    detect().os
  );

export const hideClass = (className) => {
  setInterval(() => {
    if (!className) {
      return;
    }
    const classElements = document.getElementsByClassName(className);
    for (const classElement of classElements) {
      classElement.style.display = "none";
    }
  }, 1000);
};

export const updateCSSVariables = (variables) => {
  for (const key in variables) {
    document.documentElement.style.setProperty(key, variables[key]);
  }
};

export const isInternalLink = (linkUrl) => {
  try {
    const parsedLink = new URL(linkUrl);
    return window.location.hostname === parsedLink.hostname;
  } catch (e) {
    return true;
  }
};

const initializeUrlObject = tryCatch(JSON.parse, (e, url) => ({
  url,
  openInNewWindow: !isInternalLink(url),
}));

const openLinks = ifElse(
  prop("openInNewWindow"),
  ({ url }) => window.open(url, "_blank"),
  ({ url }) => (window.location.href = url)
);

export const openLinksByLocation = pipe(initializeUrlObject, openLinks);
